module.exports = __webpack_public_path__ + "img/genesis.b3fc175f.png";